import { isEmpty } from 'lodash';
import { useMemo, useState } from 'react';
import { LayerType } from 'shared/api';
import { useAppSelector } from 'src/app/hooks';
import { selectMap3dWorkspace } from 'src/map-3d/shared/map-3d-slices';
import { type WorkspaceLayerListObj } from '../..';
import { GenerateDEMConfirmation } from './generate-dem-confirmation';
import { GenerateDEMEmptyState } from './generate-dem-empty-state';
import { GenerateDEMForm } from './generate-dem-form';

export const GenerateDEM: React.FC = () => {
  // useState.
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  // selectors.
  const { workspaceLayers } = useAppSelector(selectMap3dWorkspace);

  // useMemos.
  const visiblePointCloudLayers: WorkspaceLayerListObj = useMemo(() => {
    return Object.fromEntries(
      Object.entries(workspaceLayers)
        .filter(
          ([, layer]) => layer.show && layer.type === LayerType.PointCloud,
        )
        .sort(
          ([, layerA], [, layerB]) =>
            (layerB.zIndex ?? 0) - (layerA.zIndex ?? 0),
        ),
    );
  }, [workspaceLayers]);

  if (isEmpty(visiblePointCloudLayers)) {
    return (
      <div className="generate-dem">
        <GenerateDEMEmptyState />
      </div>
    );
  }

  return (
    <div className="generate-dem">
      {isFormSubmitted ? (
        <GenerateDEMConfirmation setIsFormSubmitted={setIsFormSubmitted} />
      ) : (
        <GenerateDEMForm
          visiblePointCloudLayers={visiblePointCloudLayers}
          setIsFormSubmitted={setIsFormSubmitted}
        />
      )}
    </div>
  );
};
